import { createApiAction } from '@app/packages/api/utils'
import type { ApiCharge, ApiCreditCardPostRequest, ApiStripePaymentIntent } from '@app/packages/api/v2/types/entities'
import type { PostChargesCloudpaymentsConfirmRequest, PostChargesCloudpaymentsRequest } from '@app/packages/api/v2/types/params'

export const postChargesCloudpayments = (request: PostChargesCloudpaymentsRequest) =>
  createApiAction('postChargesCloudpayments', dispatch =>
    dispatch<{ data: ApiCharge | ApiCreditCardPostRequest }>({ method: 'POST', endpoint: '/api/v2/charges/cloudpayments', body: JSON.stringify(request) })
  )

export const postChargesCloudpaymentsConfirm = (request: PostChargesCloudpaymentsConfirmRequest) =>
  createApiAction('postChargesCloudpaymentsConfirm', dispatch =>
    dispatch<{ data: ApiCharge }>({ method: 'POST', endpoint: '/api/v2/charges/cloudpayments/confirm', body: JSON.stringify(request) })
  )

export const postChargesStripeSetupIntent = (invoice_tracking_id: string) =>
  createApiAction('postChargesStripeSetupIntent', dispatch =>
    dispatch<{ data: ApiStripePaymentIntent }>({
      method: 'POST',
      endpoint: '/api/v2/charges/stripe/payment_intent',
      body: JSON.stringify({ invoice_tracking_id }),
    })
  )

export const postChargesCard = (invoice_tracking_id: string) =>
  createApiAction('postChargesCard', dispatch =>
    dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/charges/card', body: JSON.stringify({ invoice_tracking_id }) })
  )
